<template>
  <div class="home-box">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2 orange--text">
          Participation 1st Zonal Advisory Meeting | Month: {{ month }}
        </h3>
        <v-spacer></v-spacer>
        <go-back-btn></go-back-btn>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-form class="pa-5" v-if="zonalAdvisory && !loading">
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">
              President of the Club
            </div>
            <div class="caption">
              {{ zonalAdvisory.president_club == 1 ? "Yes" : "No" }}
            </div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">
              Secretary of the Club
            </div>
            <div class="caption">
              {{ zonalAdvisory.secretary_club == 1 ? "Yes" : "No" }}
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Treasurer of the Club</div>
            <div class="caption">
              {{ zonalAdvisory.treasurer_club == 1 ? "Yes" : "No" }}
            </div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Membership Director of the club</div>
            <div class="caption">
              {{ zonalAdvisory.membership_director_club == 1 ? "Yes" : "No" }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">No. of Officers Attended</div>
            <div class="caption">
              {{ zonalAdvisory.no_of_officers_attended }}
            </div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Date of Meeting</div>
            <div class="caption">
              {{ zonalAdvisory.date }}
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row v-if="zonalAdvisory.documents">
          <v-col
            cols="3"
            v-for="item in zonalAdvisory.documents"
            :key="item.uuid"
          >
            <v-card v-if="item.type === 'pdf'" @click="openImage(item.path)">
              <v-chip class="ma-2" color="pink" label text-color="white">
                <v-icon left>
                  mdi-file-pdf-box
                </v-icon>
                PDF document
              </v-chip>
            </v-card>
            <v-card v-else @click="openImage(item.path)">
              <v-img
                :src="item.path"
                height="150"
                class="grey darken-4"
              ></v-img>
              <v-divider></v-divider>
              <v-card-actions class="text-h6 pa-2">
                Photo
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-card>    
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import GoBackBtn from "@/components/shared/GoBackBtn";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "FirstZonalAdvisoryView",

  components: { GoBackBtn, Alert, Snackbars },

  data: () => ({
    month: "",
    role: localStorage.getItem("role"),
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      pending_comment: "",
    },
    boardMeeting: [],
    confirm: false,
    zonalAdvisory: [],
  }),

  mounted() {
    this.month = this.$route.params.month;
    this.getZonalAdvisory();
  },

  computed: {
    ...mapGetters({
      defaultExam: "defaultExam",
      defaultSubject: "defaultSubject",
    }),
  },

  methods: {
    getZonalAdvisory() {
      if (this.$route.params.aId !== null) {
        this.loading = true;
        ActivityService.getActivityInfo(
          "first-zonal-advisories",
          this.$route.params.aId
        )
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.zonalAdvisory = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.zonalAdvisory = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
    pending() {},
    submit() {},
    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
    openImage(path) {
      window.open(path, "_blank");
    },
  },
};
</script>
